<div class="c">
    <form class="upcard">

        <div class="credit">
            <p>{{publicservice.Texts.Texts['main-page1']}}</p>
            <p>{{credit}}</p>
        </div>

    </form>

    <div class="logodiv">
        <img class="logoicon" src="assets/images/recycle.png">
    </div>



    <div class="divmenu">
        <div class="wrapper">
            <form class="menu-mainpage">

                <div class="tableicon">
                    <div class="r1">
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="walletClick()">
                                <mat-icon>credit_card</mat-icon>
                            </button>
                            <p class="iconText" style="padding-bottom: 30%;">{{publicservice.Texts.Texts['main-page2']}}</p>
                        </div>
                       
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="aboutUsClick()">
                                <mat-icon>people_outline</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page6']}}</p>
                        </div>
                    </div>
                    <div class="r2">
                        <div class="profileicon">
                            <button mat-fab aria-label="profile icon" class="addreqbtn" (click)="addClick()">
                                <mat-icon>add_circle_outline</mat-icon>
                            </button>
                            <p class="iconText"  style="padding-bottom: 20%;">{{publicservice.Texts.Texts['main-page3']}}</p>
                        </div>
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="contactusClick()">
                                <mat-icon>headset_mic</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page5']}}</p>
                        </div>
                      
                    </div>

                    <div class="r3">
                        <div class="profileicon">
                                <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="getProfile()">
                                <mat-icon>person</mat-icon>
                            </button>
                            <p class="iconText" style="padding-bottom: 35%;">{{publicservice.Texts.Texts['main-page4']}}</p>
                        </div>
                        <div class="profileicon">
                            <button mat-fab color="white" style="color:#67b758" aria-label="profile icon" (click)="historyClick()">
                                <mat-icon>history</mat-icon>
                            </button>
                            <p class="iconText">{{publicservice.Texts.Texts['main-page7']}}</p>
                        </div>
                       
                    </div>



                </div>
            </form>

            <!-- <div class="scorerow">
                <p style="margin:auto 0">50 :امتیاز</p>
                <img class="diamondicon" src="assets/images/gems.png">
            </div> -->
        </div>


    </div>
    
    <div class="scorerow1">
        <p style="margin:auto 0">{{bonus}} :امتیاز</p>
        <img class="diamondicon" src="assets/images/gems.png">
    </div>
</div>

